// extracted by mini-css-extract-plugin
module.exports = {"stars":"ClutchStars_stars__nirW9","star":"ClutchStars_star__O4HOb","filled":"ClutchStars_filled__SEPdC"};